import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'api';

export type PeriodType = '24_hours' | '7_days' | '30_days' | '12_months';

export interface GraphPlot {
  plot_name: string;
  plot_values: {
    credits_consumed: number;
    credits_added: number;
  };
}

export interface CreditUsageData {
  period: string;
  total_credits_used: number;
  graph_plots: GraphPlot[];
}

export interface CreditUsageResponse {
  message: string;
  data: CreditUsageData;
}

/**
 * Hook to fetch credit usage data for a specific period
 */
export const useFetchCreditUsage = (period: PeriodType = '7_days') => {
  return useQuery({
    queryKey: ['creditUsage', period],
    queryFn: async () => {
      const response = await apiClient.get<CreditUsageResponse>(
        `/billing/dashboard/credit-usage/?period=${period}`
      );
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
